import { NgModule } from "@angular/core";

import { TestFieldNameDirective } from "./field-name.directive";
import { TestTagDirective } from "./tag.directive";

@NgModule({
  declarations: [TestFieldNameDirective, TestTagDirective],
  exports: [TestFieldNameDirective, TestTagDirective]
})
export class TestTagModule {}
